import React, { useEffect, useState } from 'react';
import { Grid, makeStyles, Button, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import PropTypes from 'prop-types';
import { HistoryOutlined, FiberManualRecord } from '@material-ui/icons';
import { orange } from '@material-ui/core/colors';
import clsx from 'clsx';
import AuditTrailModal from './Modal';
import { useQueryAuditTrailViews } from '../../hooks/useAuditTrail';
import { getUnread } from '../../helpers/audit-trail';
import { hasAutomationTabAccess } from '../../helpers/user';

const useStyles = makeStyles(theme => ({
  auditContent: {
    maxHeight: '600px',
    maxWidth: '600px',
    width: '100%',
    height: '100%',
  },
  newNotificationFadeOut: {
    color: orange[500],
    opacity: 0,
    transition: 'opacity 1s',
  },
  newNotificationFadeIn: {
    color: orange[500],
    opacity: 1,
    transition: 'opacity 1s',
  },
  buttonWrapper: {
    position: 'relative',
  },
  badge: {
    position: 'absolute',
    right: '-8px',
    top: '-8px',
    borderRadius: '50%',
    backgroundColor: theme.palette.type === 'dark' ? '#424242' : '#fff',
    fontSize: '16px',
  },
  automationStationButton: {
    width: '175px',
    height: '32px',
    marginRight: '13px',
    fontSize: '12px',
  },
}));

const AuditTrail = props => {
  const { eventMeta } = props;
  const classes = useStyles();
  const [isOpen, setIsOpenModal] = useState(false);
  const [unread, setUnread] = useState([]);
  const { data, isFetching } = useQueryAuditTrailViews(eventMeta.skybox_id);

  const handleChipClicked = () => {
    setIsOpenModal(!isOpen);
  };

  useEffect(() => {
    if (data) {
      const rowsUnread = getUnread(data);
      setUnread(rowsUnread);
    }
  }, [data]);

  return (
    <Grid container>
      <Grid item xs={12} className={classes.buttonWrapper}>
        {isFetching ? (
          <Skeleton width={200} height={50} variant="text" />
        ) : (
          <>
            {eventMeta && eventMeta.event_id && hasAutomationTabAccess() && (
              <Button
                href={`${process.env.AUTOMATION_STATION_API_URL}/automation-station/${eventMeta.event_id}`}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                color="primary"
                size="small"
                className={classes.automationStationButton}
              >
                <Typography>AUTOMATION STATION</Typography>
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              onClick={handleChipClicked}
              startIcon={<HistoryOutlined />}
              size="small"
              style={{ width: '149px', height: '32px' }}
            >
              <Typography>AUDIT HISTORY</Typography>
            </Button>
            <AuditTrailModal
              className={classes.auditContent}
              eventMeta={eventMeta}
              isOpen={isOpen}
              handleModalInteraction={handleChipClicked}
              setUnread={setUnread}
              unread={unread}
            />
          </>
        )}
        <FiberManualRecord
          className={clsx(
            classes.badge,
            unread && unread.length > 0 ? classes.newNotificationFadeIn : classes.newNotificationFadeOut
          )}
        />
      </Grid>
    </Grid>
  );
};

AuditTrail.propTypes = {
  eventMeta: PropTypes.object.isRequired,
};

export default AuditTrail;
